export default "__VITE_ASSET__DDMSIqXn__"